import styled from 'styled-components';
import { Typography } from '../ui/Typography';
import { FontWeight } from '../../styled/constants';
import { PageWrapper } from '../../styled/pageLayout.styles';

export const SearchPageTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 0 15px;
  margin-top: 0;
  text-wrap: balance;
  font-size: 18px;
  font-weight: ${FontWeight.medium};

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0 40px;
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 5px 20px 15px;
    margin-bottom: 10px;
  }
`;

export const SearchBreadcrumbsContainer = styled(PageWrapper)`
  padding-bottom: 0;
`;
